const Pause = [
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  },
  [
    ["rect", { x: "6", y: "4", width: "4", height: "16" }],
    ["rect", { x: "14", y: "4", width: "4", height: "16" }]
  ]
];

export default Pause;
